// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FilterChipGroup-base__NkDW9{display:flex;flex-wrap:wrap;gap:var(--size-2);align-content:center;align-items:center;width:var(--size-full);min-width:var(--size-0)}.FilterChipGroup-mobile__upSjx{flex-direction:column;flex-wrap:nowrap;align-items:stretch}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "FilterChipGroup-base__NkDW9",
	"mobile": "FilterChipGroup-mobile__upSjx"
};
export default ___CSS_LOADER_EXPORT___;
